/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Browse_Andamp_BuyInputs */

const en_browse_andamp_buy = /** @type {(inputs: Browse_Andamp_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse & Buy`)
};

const es_browse_andamp_buy = /** @type {(inputs: Browse_Andamp_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar & Comprar`)
};

const fr_browse_andamp_buy = /** @type {(inputs: Browse_Andamp_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcourir &amp; Acheter`)
};

const de_browse_andamp_buy = /** @type {(inputs: Browse_Andamp_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stöbern & Kaufen`)
};

const ja_browse_andamp_buy = /** @type {(inputs: Browse_Andamp_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閲覧 ＆ 購入`)
};

const zh_browse_andamp_buy = /** @type {(inputs: Browse_Andamp_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览 &amp; 购买`)
};

const ar_browse_andamp_buy = /** @type {(inputs: Browse_Andamp_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفح وشراء`)
};

const id_browse_andamp_buy = /** @type {(inputs: Browse_Andamp_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi &amp; Beli`)
};

const it_browse_andamp_buy = /** @type {(inputs: Browse_Andamp_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplorare & Acquistare`)
};

const ru_browse_andamp_buy = /** @type {(inputs: Browse_Andamp_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотреть & Покупать`)
};

const pt_browse_andamp_buy = /** @type {(inputs: Browse_Andamp_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegar & Comprar`)
};

const ko_browse_andamp_buy = /** @type {(inputs: Browse_Andamp_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`탐색 & 구매`)
};

/**
* | output |
* | --- |
* | "Browse & Buy" |
*
* @param {Browse_Andamp_BuyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const browse_andamp_buy = /** @type {((inputs?: Browse_Andamp_BuyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browse_Andamp_BuyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_browse_andamp_buy(inputs)
	if (locale === "es") return es_browse_andamp_buy(inputs)
	if (locale === "fr") return fr_browse_andamp_buy(inputs)
	if (locale === "de") return de_browse_andamp_buy(inputs)
	if (locale === "ja") return ja_browse_andamp_buy(inputs)
	if (locale === "zh") return zh_browse_andamp_buy(inputs)
	if (locale === "ar") return ar_browse_andamp_buy(inputs)
	if (locale === "id") return id_browse_andamp_buy(inputs)
	if (locale === "it") return it_browse_andamp_buy(inputs)
	if (locale === "ru") return ru_browse_andamp_buy(inputs)
	if (locale === "pt") return pt_browse_andamp_buy(inputs)
	return ko_browse_andamp_buy(inputs)
});